import React, { useEffect, useRef, useState, useMemo } from 'react';
import '../styles/Lore.css';
import { useTranslation } from 'react-i18next';
// Importando iconos
import { FaSpaceShuttle, FaUniversity, FaGlobeAmericas, FaBook } from 'react-icons/fa';
import { GiCrossedSwords, GiAlienSkull, GiBirdMask, GiDiploma } from 'react-icons/gi';
import { MdExplore } from 'react-icons/md';

// Importar imágenes
import palarNestImage from '../assets/PalarNestPanoramico.webp';
import franklinYeungImage from '../assets/FranklinYeung.webp';
import tanaNovachekImage from '../assets/TanaNovachekPanoramico.webp';
import lore2Image from '../assets/Lore2.webp';
import nacimientoPalarNest from '../assets/nacimientopalarnest.webp';
import encuentroConFranklin from '../assets/encuentroconfranklin.webp';
import ataqueAFranklin from '../assets/ataqueafranklin.webp';
import elPrimerContrato from '../assets/elprimercontrato.webp';
import fundacionCorvusCorax from '../assets/fundaciondecorvuscorax.webp';
import primeraAsambleaCorvusNocta from '../assets/primeraasambleacorvusnocta.webp';
import laEmboscadaEnPyro from '../assets/laemboscadaenpyro.webp';
import encuentroConTanaNovachek from '../assets/encuentrocontananovachek.webp';
import elNuevoRumbo from '../assets/elnuevorumbo.webp';
import retiroDePalarNest from '../assets/retirodepalarnest.webp';
import liderazgoTanaNovachek from '../assets/liderazgodetananovachek.webp';
import oberonCrisis from '../assets/OberonUriel.webp';
import magnusMission from '../assets/MagnusBoreaOdyssa.webp';
import magnusExpansion from '../assets/MagnusBoreaOdyssa.webp';
import oretaniImage from '../assets/OretaniIII.webp';
import tanaBirth from '../assets/TanaNovachek.webp';
import tanaAcademy from '../assets/TanaAcademia.webp';
import tanaAcademyExcellence from '../assets/TanaAcademia18.webp';
import tanaConsolidation from '../assets/TanaNovachek50.webp';
import tanaGraduationBg from '../assets/TanaNovachekGraduacion.webp';
import tanaInteligencia from '../assets/TanaInteligencia.webp';
import tanaContrainteligencia from '../assets/TanaContrainteligencia.webp';
import tanaTraicion from '../assets/TanaTraicion.webp';
import colaboracionTanaPalar from '../assets/ColaboracionTanaPalar.webp';
import tanaNoctaFederation from '../assets/TanaNoctaFederation.webp';
import tana4Image from '../assets/Tana4.webp';
import tanaManoDerechaImage from '../assets/TanaManoDerecha.webp';
import amberKoshobeImage from '../assets/AmberKoshobe.webp';
import amberEnlistImage from '../assets/AmberEnlist.webp';
import amberCampoBatallaImage from '../assets/AmberCampoBatalla.webp';
import amberCiudadanoLabImage from '../assets/AmberCiudadanoLab.webp';
import koshobe4Image from '../assets/Koshobe4.webp';

// Debug: verificar que las imágenes se cargan
console.log('TanaAcademia:', tanaAcademy);
console.log('TanaAcademyExcellence:', tanaAcademyExcellence);

const Lore = () => {
    const { t, i18n } = useTranslation();
    const timelineRef = useRef(null);
    const headerRef = useRef(null); // Referencia para el header
    const [activeEvent, setActiveEvent] = useState(null);
    const [filters, setFilters] = useState(['corvus', 'tana', 'sc', 'amber']); // Estado para filtros múltiples: todos activos por defecto
    const [, forceUpdate] = useState();
    
    // Función para navegar entre eventos visibles
    const navigateEvents = (direction) => {
        const visibleEvents = timelineEvents.filter(event => 
            event.type !== 'era-separator' && filters.includes(event.type)
        );
        
        if (visibleEvents.length === 0) return;
        
        let currentIndex = -1;
        if (activeEvent !== null) {
            currentIndex = visibleEvents.findIndex(event => 
                timelineEvents.indexOf(event) === parseInt(activeEvent)
            );
        }
        
        let newIndex;
        if (direction === 'next') {
            newIndex = currentIndex < visibleEvents.length - 1 ? currentIndex + 1 : 0;
        } else {
            newIndex = currentIndex > 0 ? currentIndex - 1 : visibleEvents.length - 1;
        }
        
        const targetEvent = visibleEvents[newIndex];
        const targetIndex = timelineEvents.indexOf(targetEvent);
        setActiveEvent(targetIndex.toString());
        
        // Scroll al evento
        setTimeout(() => {
            const element = document.querySelector(`[data-index="${targetIndex}"]`);
            if (element) {
                element.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
        }, 100);
    };
    
    // Forzar re-render cuando cambie el idioma
    useEffect(() => {
        forceUpdate({});
    }, [i18n.language]);

    // Función para obtener la imagen correspondiente a cada evento
    const getEventImage = (eventKey) => {
        const imageMap = {
            'palar_birth': palarNestImage,
            'franklin_meeting': [palarNestImage, franklinYeungImage],
            'franklin_attack': franklinYeungImage,
            'first_contract': palarNestImage,
            'oberon_crisis': palarNestImage,
            'corvus_corax': palarNestImage,
            'oretani_operations': palarNestImage,

            'pyro_ambush': palarNestImage,
            'magnus_mission': palarNestImage,
            'palar_retirement': palarNestImage,
            'magnus_expansion': palarNestImage,
            'first_assembly': [palarNestImage, tanaNovachekImage],
            'palar_death': palarNestImage,
            'tana_leadership': tanaNovachekImage,
            'corvus_consolidation': tanaNovachekImage,
            'modern_corvus': lore2Image,
            'tana_birth': tanaNovachekImage,
            'tana_academy': tanaNovachekImage,
            'tana_excellence': tanaNovachekImage,
            'tana_graduation': tanaNovachekImage,
            'tana_intelligence': tanaNovachekImage,
            'tana_undercover': tanaNovachekImage,
            'tana_betrayal': tanaNovachekImage,
            'tana_meeting_palar': [palarNestImage, tanaNovachekImage],
            'tana_nocturna_federation': tanaNovachekImage,
            'tana_collaboration': [palarNestImage, tanaNovachekImage],
            'tana_right_hand': [palarNestImage, tanaNovachekImage],
            'corvus_present': palarNestImage,
            'amber_birth': amberKoshobeImage,
            'amber_equivalence': amberKoshobeImage,
            'amber_citizenship': amberKoshobeImage,
            'amber_service': amberKoshobeImage,
            'amber_enrc_foundation': amberKoshobeImage,
            'amber_fcn_collaboration': amberKoshobeImage,
            'amber_tevarin_war': amberKoshobeImage,
            'amber_corvus_integration': amberKoshobeImage,

        };
        return imageMap[eventKey] || null;
    };

    // Función para crear el array de eventos con las traducciones actuales
    const timelineEvents = useMemo(() => {
        // Obtener todos los eventos del archivo de traducción
        const events = Object.entries(t('lore.events', { returnObjects: true }))
            .map(([key, event]) => ({
                year: event.year,
                type: event.type,
                eventKey: `lore.events.${key}`,
                title: event.title,
                content: event.content,
                image: getEventImage(key)
            }))
            .sort((a, b) => a.year - b.year);

        // Crear array final con separadores de era
        const timeline = [];
        
        // Añadir era antigua
        timeline.push({
            type: 'era-separator',
            era: t('lore.eras.ancient.title'),
            description: t('lore.eras.ancient.description')
        });

        // Filtrar y añadir eventos antiguos (antes del año 0)
        events.filter(e => e.year < 0).forEach(e => timeline.push(e));

        // Añadir era de expansión
        timeline.push({
            type: 'era-separator',
            era: t('lore.eras.expansion.title'),
            description: t('lore.eras.expansion.description')
        });

        // Filtrar y añadir eventos de expansión (2000-2300)
        events.filter(e => e.year >= 2000 && e.year < 2300).forEach(e => timeline.push(e));

        // Añadir era Tevarin
        timeline.push({
            type: 'era-separator',
            era: t('lore.eras.tevarin.title'),
            description: t('lore.eras.tevarin.description')
        });

        // Filtrar y añadir eventos Tevarin (2300-2450)
        events.filter(e => e.year >= 2300 && e.year < 2450).forEach(e => timeline.push(e));

        // Añadir era Messer
        timeline.push({
            type: 'era-separator',
            era: t('lore.eras.messer.title'),
            description: t('lore.eras.messer.description')
        });

        // Filtrar y añadir eventos Messer (2450-2650)
        events.filter(e => e.year >= 2450 && e.year < 2650).forEach(e => timeline.push(e));

        // Añadir era de contactos alienígenas
        timeline.push({
            type: 'era-separator',
            era: t('lore.eras.alien_contacts.title'),
            description: t('lore.eras.alien_contacts.description')
        });

        // Filtrar y añadir eventos de contactos alienígenas (2650-2750)
        events.filter(e => e.year >= 2650 && e.year < 2750).forEach(e => timeline.push(e));

        // Añadir era de opresión Messer
        timeline.push({
            type: 'era-separator',
            era: t('lore.eras.messer_oppression.title'),
            description: t('lore.eras.messer_oppression.description')
        });

        // Filtrar y añadir eventos de opresión Messer (2750-2800)
        events.filter(e => e.year >= 2750 && e.year < 2800).forEach(e => timeline.push(e));

        // Añadir era de la nueva UEE
        timeline.push({
            type: 'era-separator',
            era: t('lore.eras.new_uee.title'),
            description: t('lore.eras.new_uee.description')
        });

        // Filtrar y añadir eventos de la nueva UEE (2800-2900)
        events.filter(e => e.year >= 2800 && e.year < 2900).forEach(e => timeline.push(e));

        // Añadir era moderna
        timeline.push({
            type: 'era-separator',
            era: t('lore.eras.modern.title'),
            description: t('lore.eras.modern.description')
        });

        // Filtrar y añadir eventos modernos (2900 en adelante)
        events.filter(e => e.year >= 2900).forEach(e => timeline.push(e));

        return timeline;
    }, [t, i18n.language]); // Dependencias del useMemo

    // Obtener los eventos filtrados
    const filteredEvents = useMemo(() => {
        return timelineEvents.filter(event => 
            filters.includes(event.type) || event.type === 'era-separator'
        );
    }, [filters, timelineEvents]);

    // Función para detectar eventos compartidos entre personajes
    const getSharedEvents = useMemo(() => {
        const sharedEvents = [];
        const eventGroups = {};
        
        // Agrupar eventos por año
        timelineEvents.forEach((event, index) => {
            if (event.type !== 'era-separator') {
                if (!eventGroups[event.year]) {
                    eventGroups[event.year] = [];
                }
                eventGroups[event.year].push({ ...event, originalIndex: index });
            }
        });
        
        // Encontrar años con múltiples eventos de diferentes personajes
        Object.entries(eventGroups).forEach(([year, events]) => {
            const characterTypes = [...new Set(events.map(e => e.type))];
            if (characterTypes.length > 1) {
                sharedEvents.push({
                    year: parseInt(year),
                    events: events,
                    characters: characterTypes
                });
            }
        });
        
        return sharedEvents;
    }, [timelineEvents]);
    
    // Memoizar los índices de los eventos especiales
    const specialEventIndices = useMemo(() => {
        const indices = {};
        timelineEvents.forEach((event, index) => {
            if (event.type === 'corvus' || event.type === 'tana' || event.type === 'amber') {
                switch (event.eventKey) {
                    case 'lore.events.palar_birth':
                        indices.birth = index;
                        break;
                    case 'lore.events.franklin_meeting':
                        indices.franklinMeeting = index;
                        break;
                    case 'lore.events.franklin_attack':
                        indices.franklinAttack = index;
                        break;
                    case 'lore.events.first_contract':
                        indices.firstContract = index;
                        break;
                    case 'lore.events.oberon_crisis':
                        indices.oberonCrisis = index;
                        break;
                    case 'lore.events.corvus_corax':
                        indices.corvusCorax = index;
                        break;
                    case 'lore.events.oretani_operations':
                        indices.oretaniOperations = index;
                        break;

                    case 'lore.events.pyro_ambush':
                        indices.pyroAmbush = index;
                        break;
                    case 'lore.events.magnus_mission':
                        indices.magnusMission = index;
                        break;
                    case 'lore.events.palar_retirement':
                        indices.palarRetirement = index;
                        break;
                    case 'lore.events.magnus_expansion':
                        indices.magnusExpansion = index;
                        break;
                    case 'lore.events.first_assembly':
                        indices.firstAssembly = index;
                        break;
                    case 'lore.events.palar_death':
                        indices.palarDeath = index;
                        break;
                    case 'lore.events.tana_leadership':
                        indices.tanaLeadership = index;
                        break;
                    case 'lore.events.corvus_consolidation':
                        indices.corvusConsolidation = index;
                        break;
                    case 'lore.events.corvus_present':
                        indices.corvusPresent = index;
                        break;
                    case 'lore.events.tana_birth':
                        indices.tanaBirth = index;
                        break;
                    case 'lore.events.tana_academy':
                        indices.tanaAcademy = index;
                        break;
                    case 'lore.events.tana_excellence':
                        indices.tanaExcellence = index;
                        break;
                    case 'lore.events.tana_graduation':
                        indices.tanaGraduation = index;
                        break;
                    case 'lore.events.tana_intelligence':
                        indices.tanaIntelligence = index;
                        break;
                    case 'lore.events.tana_undercover':
                        indices.tanaUndercover = index;
                        break;
                    case 'lore.events.tana_betrayal':
                        indices.tanaBetrayal = index;
                        break;
                    case 'lore.events.tana_meeting_palar':
                        indices.tanaMeetingPalar = index;
                        break;
                    case 'lore.events.tana_nocturna_federation':
                        indices.tanaNocturnaFederation = index;
                        break;
                    case 'lore.events.tana_collaboration':
                        indices.tanaCollaboration = index;
                        break;
                    case 'lore.events.tana_right_hand':
                        indices.tanaRightHand = index;
                        break;
                    case 'lore.events.amber_birth':
                        indices.amberBirth = index;
                        break;
                    case 'lore.events.amber_equivalence':
                        indices.amberEquivalence = index;
                        break;
                    case 'lore.events.amber_citizenship':
                        indices.amberCitizenship = index;
                        break;
                    case 'lore.events.amber_service':
                        indices.amberService = index;
                        break;
                    case 'lore.events.amber_enrc_foundation':
                        indices.amberEnrcFoundation = index;
                        break;
                    case 'lore.events.amber_fcn_collaboration':
                        indices.amberFcnCollaboration = index;
                        break;
                    case 'lore.events.amber_tevarin_war':
                        indices.amberTevarinWar = index;
                        break;
                    case 'lore.events.amber_corvus_integration':
                        indices.amberCorvusIntegration = index;
                        break;

                }
            }
        });
        
        // Debug: verificar los índices de los eventos de Tana
        console.log('specialEventIndices:', indices);
        
        return indices;
    }, [timelineEvents]);
    
    // Función para obtener el icono según el título o contenido del evento
    const getEventIcon = (event) => {
        // Si es un separador de era, no mostramos icono
        if (event.type === 'era-separator') return null;
        
        const title = event.title ? event.title.toLowerCase() : '';
        const year = event.year ? event.year : '';
        
        // Para los eventos de Corvus Nocta
        if (event.type === 'corvus') {
            if (title.includes('fundación') || title.includes('nacimiento')) {
                return <GiDiploma className="event-icon" />;
            } else if (title.includes('ataque') || title.includes('emboscada')) {
                return <GiCrossedSwords className="event-icon" />;
            } else if (title.includes('asamblea') || title.includes('encuentro')) {
                return <FaUniversity className="event-icon" />;
            } else {
                return <GiBirdMask className="event-icon" />; // Icono por defecto para Corvus
            }
        } 
        // Para los eventos de Tana Novachek
        else if (event.type === 'tana') {
            if (title.includes('nacimiento') || title.includes('graduación')) {
                return <GiDiploma className="event-icon" />;
            } else if (title.includes('academia') || title.includes('excelencia')) {
                return <FaUniversity className="event-icon" />;
            } else if (title.includes('inteligencia') || title.includes('contraespionaje')) {
                return <GiCrossedSwords className="event-icon" />;
            } else {
                return <GiBirdMask className="event-icon" />; // Icono por defecto para Tana
            }
        } 
        // Para los eventos de Star Citizen
        else if (event.type === 'sc') {
            if (title.includes('guerra') || title.includes('batalla') || title.includes('conflicto')) {
                return <GiCrossedSwords className="event-icon" />;
            } else if (title.includes('descubrimiento') || title.includes('exploración')) {
                return <MdExplore className="event-icon" />;
            } else if (title.includes('contacto') || title.includes('alien')) {
                return <GiAlienSkull className="event-icon" />;
            } else if (title.includes('colonización') || title.includes('asentamiento')) {
                return <FaGlobeAmericas className="event-icon" />;
            } else if (title.includes('fundación') || title.includes('creación') || title.includes('formación')) {
                return <GiDiploma className="event-icon" />;
            } else {
                return <FaSpaceShuttle className="event-icon" />; // Icono por defecto para SC
            }
        }
        return null;
    };
    

    

    
    // Resetear activeEvent cuando cambien los filtros si el evento actual no está visible
    useEffect(() => {
        if (activeEvent !== null) {
            const currentEvent = timelineEvents[parseInt(activeEvent)];
            if (currentEvent && !filters.includes(currentEvent.type)) {
                // El evento actual no está visible, resetear
                setActiveEvent(null);
            }
        }
    }, [filters, activeEvent, timelineEvents]);
    

    
    // Función para activar manualmente un evento
    const handleEventClick = (index) => {
        setActiveEvent(index.toString());
    };

    // Función para mantener visible un detalle mientras el cursor está sobre él
    const handleDetailHover = (index, isEntering) => {
        if (isEntering) {
            setActiveEvent(index.toString());
        }
        // No hacer nada si el cursor sale - dejamos que el observer maneje esto
    };
    
    // Función para mantener los detalles visibles al hacer click en ellos
    const handleDetailClick = (index, event) => {
        // Prevenir la propagación para que no se cierre si se hace click fuera
        event.stopPropagation();
        // Mantener activo este detalle
        setActiveEvent(index.toString());
    };
    
    // Añadir un manejador para cerrar los detalles al hacer click fuera
    useEffect(() => {
        const handleOutsideClick = (event) => {
            // Verificar si el click fue dentro de un detalle o un punto
            const isInsidePoint = event.target.closest('.timeline-event-point');
            const isInsideDetail = event.target.closest('.event-detail');
            
            if (!isInsidePoint && !isInsideDetail && activeEvent !== null) {
                setActiveEvent(null);
            }
        };
        
        // Añadir el event listener
        document.addEventListener('click', handleOutsideClick);
        
        // Limpieza
        return () => {
            document.removeEventListener('click', handleOutsideClick);
        };
    }, [activeEvent]);
    
    // Función para comprobar si un elemento está cerca del header
    const isElementNearHeader = (element) => {
        const headerHeight = document.querySelector('header') ? 
            document.querySelector('header').offsetHeight : 80;
        
        const rect = element.getBoundingClientRect();
        return rect.top <= headerHeight + 10; // 10px de margen adicional
    };

    // Configuración de la detección de Intersection Observer
    const setupScrollObserver = () => {
        // Obtener la altura del header
        const headerHeight = document.querySelector('header') ? 
            document.querySelector('header').offsetHeight : 80;
        
        const options = {
            root: null,
            rootMargin: `-${headerHeight}px 0px 150px 0px`,
            threshold: [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1.0] // Más thresholds para detección más precisa
        };
        
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                const eventId = entry.target.getAttribute('data-event-id');
                
                if (entry.isIntersecting) {
                    if (eventId) {
                        // Basta con que sea mínimamente visible para activarlo
                        if (entry.intersectionRatio >= 0.2) {
                            // Comprobar si está cerca del header
                            if (!isElementNearHeader(entry.target)) {
                                setActiveEvent(eventId);
                                entry.target.classList.add('active');
                            }
                        }
                    }
                } else {
                    // Verificar si el punto está cerca del borde superior (header)
                    const isNearHeader = isElementNearHeader(entry.target);
                    
                    // Solo desactivar si está cerca del header
                    if (isNearHeader) {
                        entry.target.classList.remove('active');
                        
                        // Si este era el evento activo, desactivarlo
                        if (activeEvent === eventId) {
                            setActiveEvent(null);
                        }
                    }
                }
            });
        }, options);
        
        // Observar todos los puntos de evento (incluyendo eventos compartidos) con un pequeño delay para asegurar que el DOM esté listo
        setTimeout(() => {
            document.querySelectorAll('.timeline-event-point, .shared-event-point').forEach(point => {
                observer.observe(point);
            });
        }, 100);
        
        return observer;
    };
    
    // Función para renderizar las líneas de personajes
    const renderCharacterLines = () => {
        const characterTypes = ['corvus', 'tana', 'amber', 'sc'];
        
        return (
            <div className="character-lines">
                {characterTypes.map(characterType => (
                    <div 
                        key={characterType}
                        className={`character-line ${characterType}`}
                        style={{
                            opacity: filters.includes(characterType) ? 1 : 0.3
                        }}
                    />
                ))}
                
                {/* Puntos de conexión para eventos compartidos */}
                {getSharedEvents.map((sharedEvent, index) => {
                    const eventElement = document.querySelector(`[data-year="${sharedEvent.year}"]`);
                    if (!eventElement) return null;
                    
                    const rect = eventElement.getBoundingClientRect();
                    const timelineRect = timelineRef.current?.getBoundingClientRect();
                    
                    if (!timelineRect) return null;
                    
                    const top = rect.top - timelineRect.top;
                    
                    return (
                        <div key={`connection-${index}`}>
                            <div 
                                className="connection-line"
                                style={{ 
                                    top: `${top}px`,
                                    width: '60px'
                                }}
                            />
                        </div>
                    );
                })}
            </div>
        );
    };
    
    // Renderizar cada evento del timeline
    const renderTimelineEvents = () => {
        return filteredEvents.map((event, filteredIndex) => {
            // Encontrar el índice real en timelineEvents usando eventKey
            const realIndex = timelineEvents.findIndex(e => e.eventKey === event.eventKey);
            const index = realIndex !== -1 ? realIndex : filteredIndex;
            if (event.type === 'era-separator') {
                return (
                    <div key={`era-${event.era}-${filteredIndex}`} className="era-separator">
                        <div className="era-marker"></div>
                        <div className="era-details">
                            <h2 className="era-title">{event.era}</h2>
                            <p className="era-description">{event.description}</p>
                        </div>
                        {/* Puntos de era en las líneas de tiempo */}
                        <div className="era-timeline-points">
                            <div className="era-point sc-point"></div>
                            <div className="era-point corvus-point"></div>
                            <div className="era-point tana-point"></div>
                            <div className="era-point amber-point"></div>
                        </div>
                    </div>
                );
            }

            // Evento regular de timeline
            const isOdd = index % 2 !== 0;
            const eventKey = event.eventKey || `event-${index}-${filteredIndex}`;
            

            
            return (
                <div 
                    key={eventKey}
                    className={`timeline-event ${Array.isArray(event.image) ? 'shared-event' : ''}`}
                    data-type={event.type}
                    data-index={index}
                    data-year={event.year}
                    data-event-key={event.eventKey}
                >
                    {Array.isArray(event.image) ? (
                        // Si hay múltiples imágenes, mostrar puntos en ambas líneas
                        <>
                            <div 
                                className={`shared-event-point corvus-point ${activeEvent === index.toString() ? 'active' : ''}`}
                                data-event-id={index}
                                data-tooltip={t('lore.labels.clickToView')}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    handleEventClick(index);
                                }}
                            >
                                {getEventIcon(event)}
                            </div>
                            <div 
                                className={`shared-event-point tana-point ${activeEvent === index.toString() ? 'active' : ''}`}
                                data-event-id={index}
                                data-tooltip={t('lore.labels.clickToView')}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    handleEventClick(index);
                                }}
                            >
                                {getEventIcon(event)}
                            </div>
                        </>
                    ) : (
                        // Si hay una sola imagen, mostrar solo un punto
                    <div 
                        className={`timeline-event-point ${activeEvent === index.toString() ? 'active' : ''}`}
                        data-event-id={index}
                        data-tooltip={t('lore.labels.clickToView')}
                        onClick={(e) => {
                            e.stopPropagation();
                            handleEventClick(index);
                        }}
                    >
                        {getEventIcon(event)}
                    </div>
                    )}
                    
                    <div className={`event-year ${isOdd ? 'right-align' : 'left-align'}`}>
                        {event.year}
                    </div>
                    
                    <div 
                        className={`event-detail ${Array.isArray(event.image) ? 'shared-event-detail' : ''} ${activeEvent === index.toString() ? 'active' : ''}`}
                        onMouseEnter={() => handleDetailHover(index, true)}
                        onMouseLeave={() => handleDetailHover(index, false)}
                        onClick={(e) => handleDetailClick(index, e)}
                    >
                        <div className="event-header">
                            <h3 className="event-title">
                                <span className="event-year-title">{event.year}</span>{' '}
                                {event.title}
                            </h3>
                            <div className="event-badges">
                                {Array.isArray(event.image) ? (
                                    // Si hay múltiples imágenes, mostrar etiquetas de ambos personajes
                                    <>
                                        <span className="event-badge corvus">
                                            {t('lore.labels.palarNest')}
                                        </span>
                                        <span className="event-badge tana">
                                            {t('lore.labels.tanaNovachek')}
                                        </span>
                                    </>
                                ) : (
                                    // Si hay una sola imagen, mostrar la etiqueta del personaje correspondiente
                                    <span className={`event-badge ${event.type}`}>
                                {event.type === 'corvus' 
                                            ? t('lore.labels.palarNest') 
                                            : event.type === 'tana'
                                            ? t('lore.labels.tanaNovachek')
                                            : event.type === 'amber'
                                            ? t('lore.labels.amberKoshobe')
                                    : t('lore.labels.starCitizen')}
                            </span>
                                )}
                            </div>
                        </div>
                        
                        {event.image && (
                            <div className="event-image-container" 
                                data-name={event.title}
                            >
                                {Array.isArray(event.image) ? (
                                    <div className="multiple-images">
                                        {event.image.map((img, idx) => (
                                            <img 
                                                key={idx}
                                                src={img} 
                                                alt={`${event.title} - Personaje ${idx + 1}`} 
                                                className="event-image" 
                                                loading="eager" 
                                                fetchpriority="high"
                                            />
                                        ))}
                                    </div>
                                ) : (
                                    <img 
                                        src={event.image} 
                                        alt={event.title} 
                                        className="event-image" 
                                        loading="eager" 
                                        fetchpriority="high"
                                    />
                                )}
                            </div>
                        )}
                        
                        <div className="event-content">
                            <p>{event.content}</p>
                        </div>
                    </div>
                </div>
            );
        });
    };

    // Función para añadir texto curvado a las imágenes
    useEffect(() => {
        // Pre-renderizar los detalles para evitar retrasos en la carga
        const preloadEventDetails = () => {
            // Recorrer todos los eventos y "simular" un hover para que se precargen las traducciones
            timelineEvents.forEach((event, index) => {
                if (event.type !== 'era-separator' && event.eventKey) {
                    // Precargar las traducciones de títulos
                    if (event.eventKey) {
                        t(event.eventKey, { returnObjects: true });
                    }
                    
                    // Precargar las traducciones de contenido
                    if (event.content && event.content.startsWith('lore.')) {
                        const contentKey = event.content;
                        t(contentKey, { returnObjects: true });
                        
                        // También precargar las partes adicionales si existen
                        const contentBase = contentKey.substring(0, contentKey.lastIndexOf('.') + 1);
                        let i = 2;
                        while (i <= 5) { // Limitar a un máximo razonable
                            const additionalKey = `${contentBase}content${i}`;
                            t(additionalKey, { defaultValue: '' });
                            i++;
                        }
                    }
                }
            });
        };
        
        const addCurvedText = () => {
            const textContainers = document.querySelectorAll('.event-image-container');
            textContainers.forEach(container => {
                if (!container.getAttribute('data-name')) return;
                
                // Eliminar SVG previos si existen
                const oldSvg = container.querySelector('svg');
                if (oldSvg) {
                    oldSvg.remove();
                }
                
                // Crear SVG para texto curvo
                const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
                
                // Crear un camino para el texto
                const textPath = document.createElementNS("http://www.w3.org/2000/svg", "path");
                const containerWidth = 150; // Ancho del contenedor de la imagen
                
                // Calcular el radio para el path (un poco más grande que la imagen)
                const radius = containerWidth / 2 + 15;
                
                // Crear un arco para la parte inferior
                const pathData = `M 20,${radius * 1.2} A ${radius},${radius} 0 0,1 ${containerWidth - 20},${radius * 1.2}`;
                textPath.setAttribute("d", pathData);
                textPath.setAttribute("id", `textPath-${container.getAttribute('data-name').replace(/\s+/g, '-').toLowerCase()}`);
                textPath.setAttribute("fill", "none");
                svg.appendChild(textPath);
                
                // Crear el texto que seguirá el camino
                const text = document.createElementNS("http://www.w3.org/2000/svg", "text");
                text.setAttribute("class", "curve-text");
                
                // Crear referencia al camino
                const textPathRef = document.createElementNS("http://www.w3.org/2000/svg", "textPath");
                textPathRef.setAttribute("href", `#textPath-${container.getAttribute('data-name').replace(/\s+/g, '-').toLowerCase()}`);
                textPathRef.setAttribute("startOffset", "50%");
                textPathRef.setAttribute("text-anchor", "middle");
                textPathRef.textContent = container.getAttribute('data-name');
                
                text.appendChild(textPathRef);
                svg.appendChild(text);
                
                // Añadir el SVG al contenedor
                container.appendChild(svg);
            });
        };
        
        // Establecer un evento activo por defecto (para que siempre haya algo visible)
        const setInitialActiveEvent = () => {
            // Primero buscar si ya hay un evento activo por URL o context
            if (activeEvent !== null) return;
            
            // Si no, buscar el primer evento que no sea un separador
            for (let i = 0; i < timelineEvents.length; i++) {
                if (timelineEvents[i].type !== 'era-separator') {
                    setActiveEvent(i.toString());
                    break;
                }
            }
        };
        
        // Ejecutar todo de manera organizada para optimizar el rendimiento
        const initTimeline = async () => {
            // Primero, precargar las traducciones y textos
            preloadEventDetails();
            
            // Pequeño delay para asegurar que el DOM esté listo (usar requestAnimationFrame es más eficiente)
            requestAnimationFrame(() => {
                // Luego, establecer el evento activo inicial
                setInitialActiveEvent();
                
                // Finalmente, añadir los textos curvos
                addCurvedText();
                
                // Configurar el observer después de todo lo demás
                const observer = setupScrollObserver();
                
                // Guardar el observer para limpieza
                window.timelineObserver = observer;
            });
        };
        
        // Iniciar el timeline
        initTimeline();
        
        // Limpiar al desmontar
        return () => {
            const svgs = document.querySelectorAll('.event-image-container svg');
            svgs.forEach(svg => svg.remove());
            if (window.timelineObserver) {
                window.timelineObserver.disconnect();
                delete window.timelineObserver;
            }
        };
    }, [t, timelineEvents, activeEvent]);

    return (
        <div className="lore-page" style={{ 
            backgroundColor: (
                activeEvent === specialEventIndices.birth?.toString() || 
                activeEvent === specialEventIndices.franklinMeeting?.toString() ||
                activeEvent === specialEventIndices.franklinAttack?.toString() ||
                activeEvent === specialEventIndices.firstContract?.toString() ||
                activeEvent === specialEventIndices.oberonCrisis?.toString() ||
                activeEvent === specialEventIndices.corvusCorax?.toString() ||
                activeEvent === specialEventIndices.oretaniOperations?.toString() ||

                activeEvent === specialEventIndices.pyroAmbush?.toString() ||
                activeEvent === specialEventIndices.magnusMission?.toString() ||
                activeEvent === specialEventIndices.palarRetirement?.toString() ||
                activeEvent === specialEventIndices.magnusExpansion?.toString() ||
                activeEvent === specialEventIndices.firstAssembly?.toString() ||
                activeEvent === specialEventIndices.palarDeath?.toString() ||
                activeEvent === specialEventIndices.tanaLeadership?.toString() ||
                activeEvent === specialEventIndices.corvusConsolidation?.toString() ||
                activeEvent === specialEventIndices.tanaBirth?.toString() ||
                activeEvent === specialEventIndices.tanaAcademy?.toString() ||
                activeEvent === specialEventIndices.tanaExcellence?.toString() ||
                activeEvent === specialEventIndices.tanaGraduation?.toString() ||
                activeEvent === specialEventIndices.tanaIntelligence?.toString() ||
                activeEvent === specialEventIndices.tanaUndercover?.toString() ||
                activeEvent === specialEventIndices.tanaBetrayal?.toString() ||
                activeEvent === specialEventIndices.tanaMeetingPalar?.toString() ||
                activeEvent === specialEventIndices.tanaNocturnaFederation?.toString() ||
                activeEvent === specialEventIndices.tanaCollaboration?.toString() ||
                activeEvent === specialEventIndices.tanaRightHand?.toString() ||
                activeEvent === specialEventIndices.corvusPresent?.toString() ||
                activeEvent === specialEventIndices.amberBirth?.toString() ||
                activeEvent === specialEventIndices.amberEquivalence?.toString() ||
                activeEvent === specialEventIndices.amberCitizenship?.toString() ||
                activeEvent === specialEventIndices.amberService?.toString() ||
                activeEvent === specialEventIndices.amberEnrcFoundation?.toString() ||
                activeEvent === specialEventIndices.amberFcnCollaboration?.toString() ||
                activeEvent === specialEventIndices.amberTevarinWar?.toString() ||
                activeEvent === specialEventIndices.amberCorvusIntegration?.toString()
            ) ? 'transparent' : 'var(--dark)' 
        }}>
            {activeEvent === specialEventIndices.birth?.toString() && (
                <div 
                    className="background-image"
                    style={{
                        backgroundImage: `url(${nacimientoPalarNest})`,
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        zIndex: -1,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        opacity: 0.6,
                        pointerEvents: 'none'
                    }}
                />
            )}
            {activeEvent === specialEventIndices.franklinMeeting?.toString() && (
                <div 
                    className="background-image"
                    style={{
                        backgroundImage: `url(${encuentroConFranklin})`,
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        zIndex: -1,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        opacity: 0.6,
                        pointerEvents: 'none'
                    }}
                />
            )}
            {activeEvent === specialEventIndices.franklinAttack?.toString() && (
                <div 
                    className="background-image"
                    style={{
                        backgroundImage: `url(${ataqueAFranklin})`,
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        zIndex: -1,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        opacity: 0.6,
                        pointerEvents: 'none'
                    }}
                />
            )}
            {activeEvent === specialEventIndices.firstContract?.toString() && (
                <div 
                    className="background-image"
                    style={{
                        backgroundImage: `url(${elPrimerContrato})`,
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        zIndex: -1,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        opacity: 0.6,
                        pointerEvents: 'none'
                    }}
                />
            )}
            {activeEvent === specialEventIndices.corvusCorax?.toString() && (
                <div 
                    className="background-image"
                    style={{
                        backgroundImage: `url(${fundacionCorvusCorax})`,
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        zIndex: -1,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        opacity: 0.6,
                        pointerEvents: 'none'
                    }}
                />
            )}
            {activeEvent === specialEventIndices.firstAssembly?.toString() && (
                <div 
                    className="background-image"
                    style={{
                        backgroundImage: `url(${primeraAsambleaCorvusNocta})`,
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        zIndex: -1,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center top',
                        opacity: 0.6,
                        pointerEvents: 'none'
                    }}
                />
            )}
            {activeEvent === specialEventIndices.pyroAmbush?.toString() && (
                <div 
                    className="background-image"
                    style={{
                        backgroundImage: `url(${laEmboscadaEnPyro})`,
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        zIndex: -1,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        opacity: 0.6,
                        pointerEvents: 'none'
                    }}
                />
            )}

            {activeEvent === specialEventIndices.newDirection?.toString() && (
                <div 
                    className="background-image"
                    style={{
                        backgroundImage: `url(${elNuevoRumbo})`,
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        zIndex: -1,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        opacity: 0.6,
                        pointerEvents: 'none'
                    }}
                />
            )}
            {activeEvent === specialEventIndices.palarRetirement?.toString() && (
                <div 
                    className="background-image"
                    style={{
                        backgroundImage: `url(${retiroDePalarNest})`,
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        zIndex: -1,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        opacity: 0.6,
                        pointerEvents: 'none'
                    }}
                />
            )}
            {activeEvent === specialEventIndices.tanaLeadership?.toString() && (
                <div 
                    className="background-image"
                    style={{
                        backgroundImage: `url(${liderazgoTanaNovachek})`,
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        zIndex: -1,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        opacity: 0.6,
                        pointerEvents: 'none'
                    }}
                />
            )}
            {activeEvent === specialEventIndices.oberonCrisis?.toString() && (
                <div 
                    className="background-image"
                    style={{
                        backgroundImage: `url(${oberonCrisis})`,
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        zIndex: -1,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        opacity: 0.6,
                        pointerEvents: 'none'
                    }}
                />
            )}
            {activeEvent === specialEventIndices.magnusMission?.toString() && (
                <div 
                    className="background-image"
                    style={{
                        backgroundImage: `url(${magnusMission})`,
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        zIndex: -1,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        opacity: 0.6,
                        pointerEvents: 'none'
                    }}
                />
            )}
            {activeEvent === specialEventIndices.magnusExpansion?.toString() && (
                <div 
                    className="background-image"
                    style={{
                        backgroundImage: `url(${magnusExpansion})`,
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        zIndex: -1,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        opacity: 0.6,
                        pointerEvents: 'none'
                    }}
                />
            )}
            {activeEvent === specialEventIndices.palarDeath?.toString() && (
                <div 
                    className="background-image"
                    style={{
                        backgroundImage: `url(${palarNestImage})`,
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        zIndex: -1,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        opacity: 0.6,
                        pointerEvents: 'none'
                    }}
                />
            )}
            {activeEvent === specialEventIndices.oretaniOperations?.toString() && (
                <div 
                    className="background-image"
                    style={{
                        backgroundImage: `url(${oretaniImage})`,
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        zIndex: -1,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        opacity: 0.6,
                        pointerEvents: 'none'
                    }}
                />
            )}
            {activeEvent === specialEventIndices.corvusConsolidation?.toString() && (
                <div 
                    className="background-image"
                    style={{
                        backgroundImage: `url(${tanaConsolidation})`,
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        zIndex: -1,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        opacity: 0.6,
                        pointerEvents: 'none'
                    }}
                />
            )}
            {activeEvent === specialEventIndices.tanaBirth?.toString() && (
                <div 
                    className="background-image"
                    style={{
                        backgroundImage: `url(${tana4Image})`,
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        zIndex: -1,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        opacity: 0.6,
                        pointerEvents: 'none'
                    }}
                />
            )}
            {activeEvent === specialEventIndices.tanaAcademy?.toString() && (
                <div 
                    className="background-image"
                    style={{
                        backgroundImage: `url(${tanaAcademy})`,
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        zIndex: -1,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        opacity: 0.6,
                        pointerEvents: 'none'
                    }}
                />
            )}
            {activeEvent === specialEventIndices.tanaExcellence?.toString() && (
                <div 
                    className="background-image"
                    style={{
                        backgroundImage: `url(${tanaAcademyExcellence})`,
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        zIndex: -1,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        opacity: 0.6,
                        pointerEvents: 'none'
                    }}
                />
            )}
            {activeEvent === specialEventIndices.tanaAcademy?.toString() && (
                <div 
                    className="background-image"
                    style={{
                        backgroundImage: `url(${tanaAcademy})`,
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        zIndex: -1,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        opacity: 0.6,
                        pointerEvents: 'none'
                    }}
                />
            )}
            {activeEvent === specialEventIndices.tanaGraduation?.toString() && (
                <div 
                    className="background-image"
                    style={{
                        backgroundImage: `url(${tanaGraduationBg})`,
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        zIndex: -1,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        opacity: 0.6,
                        pointerEvents: 'none'
                    }}
                />
            )}
            {activeEvent === specialEventIndices.tanaIntelligence?.toString() && (
                <div 
                    className="background-image"
                    style={{
                        backgroundImage: `url(${tanaInteligencia})`,
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        zIndex: -1,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        opacity: 0.6,
                        pointerEvents: 'none'
                    }}
                />
            )}
            {activeEvent === specialEventIndices.tanaUndercover?.toString() && (
                <div 
                    className="background-image"
                    style={{
                        backgroundImage: `url(${tanaContrainteligencia})`,
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        zIndex: -1,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center top',
                        opacity: 0.6,
                        pointerEvents: 'none'
                    }}
                />
            )}
            {activeEvent === specialEventIndices.tanaBetrayal?.toString() && (
                <div 
                    className="background-image"
                    style={{
                        backgroundImage: `url(${tanaTraicion})`,
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        zIndex: -1,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center top',
                        opacity: 0.6,
                        pointerEvents: 'none'
                    }}
                />
            )}
            {activeEvent === specialEventIndices.tanaMeetingPalar?.toString() && (
                <div 
                    className="background-image"
                    style={{
                        backgroundImage: `url(${encuentroConTanaNovachek})`,
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        zIndex: -1,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        opacity: 0.6,
                        pointerEvents: 'none'
                    }}
                />
            )}
            {activeEvent === specialEventIndices.tanaNocturnaFederation?.toString() && (
                <div 
                    className="background-image"
                    style={{
                        backgroundImage: `url(${tanaNoctaFederation})`,
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        zIndex: -1,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        opacity: 0.6,
                        pointerEvents: 'none'
                    }}
                />
            )}
            {activeEvent === specialEventIndices.tanaCollaboration?.toString() && (
                <div 
                    className="background-image"
                    style={{
                        backgroundImage: `url(${colaboracionTanaPalar})`,
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        zIndex: -1,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        opacity: 0.6,
                        pointerEvents: 'none'
                    }}
                />
            )}
            {activeEvent === specialEventIndices.tanaRightHand?.toString() && (
                <div 
                    className="background-image"
                    style={{
                        backgroundImage: `url(${tanaManoDerechaImage})`,
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        zIndex: -1,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        opacity: 0.6,
                        pointerEvents: 'none'
                    }}
                />
            )}
            {activeEvent === specialEventIndices.corvusPresent?.toString() && (
                <div 
                    className="background-image"
                    style={{
                        backgroundImage: `url(${palarNestImage})`,
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        zIndex: -1,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        opacity: 0.6,
                        pointerEvents: 'none'
                    }}
                />
            )}
            {activeEvent === specialEventIndices.amberBirth?.toString() && (
                <div 
                    className="background-image"
                    style={{
                        backgroundImage: `url(${koshobe4Image})`,
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        zIndex: -1,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center top',
                        opacity: 0.6,
                        pointerEvents: 'none'
                    }}
                />
            )}
            {activeEvent === specialEventIndices.amberEquivalence?.toString() && (
                <div 
                    className="background-image"
                    style={{
                        backgroundImage: `url(${amberEnlistImage})`,
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        zIndex: -1,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center top',
                        opacity: 0.6,
                        pointerEvents: 'none'
                    }}
                />
            )}
            {activeEvent === specialEventIndices.amberCitizenship?.toString() && (
                <div 
                    className="background-image"
                    style={{
                        backgroundImage: `url(${amberCampoBatallaImage})`,
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        zIndex: -1,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center top',
                        opacity: 0.6,
                        pointerEvents: 'none'
                    }}
                />
            )}
            {activeEvent === specialEventIndices.amberService?.toString() && (
                <div 
                    className="background-image"
                    style={{
                        backgroundImage: `url(${amberCiudadanoLabImage})`,
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        zIndex: -1,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center top',
                        opacity: 0.6,
                        pointerEvents: 'none'
                    }}
                />
            )}
            {activeEvent === specialEventIndices.amberEnrcFoundation?.toString() && (
                <div 
                    className="background-image"
                    style={{
                        backgroundImage: `url(${amberKoshobeImage})`,
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        zIndex: -1,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center top',
                        opacity: 0.6,
                        pointerEvents: 'none'
                    }}
                />
            )}
            {activeEvent === specialEventIndices.amberFcnCollaboration?.toString() && (
                <div 
                    className="background-image"
                    style={{
                        backgroundImage: `url(${amberKoshobeImage})`,
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        zIndex: -1,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center top',
                        opacity: 0.6,
                        pointerEvents: 'none'
                    }}
                />
            )}
            {activeEvent === specialEventIndices.amberTevarinWar?.toString() && (
                <div 
                    className="background-image"
                    style={{
                        backgroundImage: `url(${amberKoshobeImage})`,
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        zIndex: -1,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center top',
                        opacity: 0.6,
                        pointerEvents: 'none'
                    }}
                />
            )}
            {activeEvent === specialEventIndices.amberCorvusIntegration?.toString() && (
                <div 
                    className="background-image"
                    style={{
                        backgroundImage: `url(${amberKoshobeImage})`,
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        zIndex: -1,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center top',
                        opacity: 0.6,
                        pointerEvents: 'none'
                    }}
                />
            )}

            <div ref={headerRef} className="timeline-header-reference"></div>
            <div className="timeline-container">
                <h1 className="timeline-title">{t('lore.timelineTitle', 'Línea Temporal')}</h1>
                
                {/* Filtros de eventos - ORDEN: IZQUIERDA UNIVERSO, CENTRO PALAR, DERECHA TANA */}
                <div className="timeline-filter">
                    <button 
                        className={`filter-button ${filters.includes('sc') ? 'active' : ''}`}
                        data-filter="sc"
                        onClick={() => {
                            if (filters.includes('sc')) {
                                setFilters(filters.filter(f => f !== 'sc'));
                            } else {
                                setFilters([...filters, 'sc']);
                            }
                        }}
                    >
                        {t('lore.labels.starCitizen', 'Star Citizen')}
                    </button>
                    <button 
                        className={`filter-button ${filters.includes('corvus') ? 'active' : ''}`}
                        onClick={() => {
                            if (filters.includes('corvus')) {
                                setFilters(filters.filter(f => f !== 'corvus'));
                            } else {
                                setFilters([...filters, 'corvus']);
                            }
                        }}
                    >
                        {t('lore.labels.palarNest', 'Palar Nest')}
                    </button>
                    <button 
                        className={`filter-button ${filters.includes('tana') ? 'active' : ''}`}
                        onClick={() => {
                            if (filters.includes('tana')) {
                                setFilters(filters.filter(f => f !== 'tana'));
                            } else {
                                setFilters([...filters, 'tana']);
                            }
                        }}
                    >
                        {t('lore.labels.tanaNovachek', 'Tana Novachek')}
                    </button>
                    <button 
                        className={`filter-button ${filters.includes('amber') ? 'active' : ''}`}
                        onClick={() => {
                            if (filters.includes('amber')) {
                                setFilters(filters.filter(f => f !== 'amber'));
                            } else {
                                setFilters([...filters, 'amber']);
                            }
                        }}
                    >
                        {t('lore.labels.amberKoshobe', 'Amber Koshobe')}
                    </button>
                </div>
                
                <div className="timeline-line" ref={timelineRef}>
                    {renderCharacterLines()}
                    {renderTimelineEvents()}
                </div>
                
                {/* Menú de navegación */}
                <div className="timeline-navigation">
                            <button 
                        className="nav-button prev-button"
                        onClick={() => navigateEvents('prev')}
                        title={t('lore.navigation.previous', 'Evento anterior')}
                    >
                        ↑
                            </button>
                            <button 
                        className="nav-button next-button"
                        onClick={() => navigateEvents('next')}
                        title={t('lore.navigation.next', 'Siguiente evento')}
                    >
                        ↓
                            </button>
                        </div>
            </div>
        </div>
    );
};

export default Lore;